import React from 'react';

import qs, { ParsedQs } from 'qs';

import { TaxonomyFilterInput } from '../../types/apiTypes';
import { routerHooks } from '../routerHooks/routerHooks';

export type FiltersQuery = {
  [vocabularyID: string]: string[];
};

export const queryStringHooks = {
  useParsedQueryString(): ParsedQs {
    const search = routerHooks.useGetQueryString();
    return React.useMemo(() =>
      qs.parse(search, { ignoreQueryPrefix: true }) as ParsedQs, [search]);
  },

  usePageQueryParam() {
    const { page } = queryStringHooks.useParsedQueryString();
    return page ? parseInt(page as string) : 1;
  },

  useQueryStringParams(filters: TaxonomyFilterInput[] | null) {
    const filtersQueryString: ParsedQs =
      React.useMemo(() => (filters || []).reduce((acc, filter) => {
        acc[filter.vocabularyID] = filter.terms;
        return acc;
      }, {} as FiltersQuery), [filters]);
    const query = React.useMemo(() => ({
      ...filtersQueryString,
    }), [filtersQueryString]);

    return qs.stringify(query);
  },

  useQueryStringParamsCallBack() {
    return React.useCallback((filters: TaxonomyFilterInput[] | null) => {
      const filtersQueryString: ParsedQs = (filters || []).reduce((acc, filter) => {
        acc[filter.vocabularyID] = filter.terms;
        return acc;
      }, {} as FiltersQuery);

      return qs.stringify(filtersQueryString);
    }, []);
  },
};
